import { render } from "./AddonCatalogo.vue?vue&type=template&id=c3b1ce7e&scoped=true"
import script from "./AddonCatalogo.vue?vue&type=script&lang=js"
export * from "./AddonCatalogo.vue?vue&type=script&lang=js"

import "./AddonCatalogo.vue?vue&type=style&index=0&id=c3b1ce7e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3b1ce7e"]])

export default __exports__